<template>
  <div class="modal-card" style="width: 30cm">
    <header class="modal-card-head">
      <p class="modal-card-title">Project Gebouwen en Verdiepingen</p>
    </header>
    <section class="modal-card-body">
      <naming-table v-bind:data="data" type="Gebouw"></naming-table>
      <h4 class="title is-4">Wilt u voor alle gebouwen ook verdiepingen toevoegen?</h4>
      <h6 class="subtitle is-6">Dit kunt u later ook nog per gebouw doen</h6>
      <div class="field">
        <b-radio v-model="radioStories" native-value="true" type="is-success">Ja</b-radio>
        <b-radio v-model="radioStories" native-value="false" type="is-danger">Nee</b-radio>
      </div>
      <naming-table v-bind:data="data2" type="Verdieping" v-if="radioStories == 'true'"></naming-table>
      <div v-if="radioStories == 'true'">
        <h4 class="title is-4">Wilt u voor alle verdiepingen ook zones toevoegen?</h4>
        <h6 class="subtitle is-6">Dit kunt u later ook nog per verdieping doen</h6>
        <div class="field">
          <b-radio v-model="radioZones" native-value="true" type="is-success">Ja</b-radio>
          <b-radio v-model="radioZones" native-value="false" type="is-danger">Nee</b-radio>
        </div>
        <naming-table v-bind:data="data3" type="Zone" v-if="radioZones == 'true'"></naming-table>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">Close</button>
      <button class="button is-primary" @click.prevent="add()" :disabled="radioStories == 'default'">Maak aan</button>
    </footer>
  </div>
</template>
<script>
import ProjectService from '@/services/projectService'
import NamingTable from '@/components/Projects/NamingTable'
import { mapGetters } from 'vuex'

export default {
  components: { NamingTable },
  props: ['projectData', 'createProjectBool'],
  data() {
    return {
      land: 'Nederland',
      organisatie: 'Atlas Techrin International',
      data: [{ order: 1, norder: 0, name: 'Voorbeeld Gebouw 1' }],
      data2: [
        { order: 1, norder: 0, name: 'Begane Grond' },
        { order: 2, norder: 1, name: '1e Verdieping' },
        { order: 3, norder: 2, name: '2e Verdieping' }
      ],
      data3: [
        { order: 1, norder: 0, name: 'Zone A' },
        { order: 2, norder: 1, name: 'Zone B' },
        { order: 3, norder: 2, name: 'Zone C' }
      ],
      radioStories: 'default',
      radioZones: 'default',
      projectId: 0
    }
  },
  computed: {
    ...mapGetters(['project'])
  },
  methods: {
    async add() {
      if (this.createProjectBool) {
        this.projectId = await this.createProject()
      } else {
        this.projectId = this.projectData.projectId
      }
      this.createBuilding()
    },
    async createProject() {
      const res = await ProjectService.createProject(this.projectData)
      this.$store.commit('addToProjectList', res.data)
      const projectId = res.data.projectId
      return projectId
    },
    async createBuilding() {
      for (let i = 1; i <= this.data.length; i++) {
        const index = this.data.findIndex(o => o.order === i)
        const responseBuilding = await ProjectService.assignBuildingToProject({
          projectId: this.projectId,
          name: this.data[index].name
        })
        const buildingId = responseBuilding.data
        if (this.radioStories == 'true') {
          for (let j = 1; j <= this.data2.length; j++) {
            const indexStory = this.data2.findIndex(o => o.order === j)
            const responseStory = await ProjectService.assignStoryToBuilding({
              projectId: this.projectId,
              buildingId: buildingId,
              name: this.data2[indexStory].name
            })
            const storyId = responseStory.data
            if (this.radioZones == 'true') {
              for (let k = 1; k <= this.data3.length; k++) {
                const indexZone = this.data3.findIndex(o => o.order === k)
                const responseZone = await ProjectService.assignZoneToStory({
                  projectId: this.projectId,
                  storyId: storyId,
                  name: this.data3[indexZone].name
                })
              }
            }
          }
        }
      }
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/BuildingModal.vue